import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

// Live credential check against AlpineIQ. Pass {api_key, uid} from the form
// (either may be omitted to fall back to the saved org config). The endpoint
// always answers 200 with {ok, detail} so failures render inline.
export const checkAlpineiqConnection = createAsyncThunk(
  "check_alpineiq_connection",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/alpineiq/check/`,
        params || {},
        config
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

// The org's AlpineIQ rewards catalog (discount templates redeemable for
// points) — a live AIQ read, so it loads separately from the overview.
export const getAlpineiqDiscounts = createAsyncThunk(
  "get_alpineiq_discounts",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/alpineiq/discounts/`,
        {},
        config
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

// Local sync stats for the AlpineIQ section page (no AIQ calls server-side).
export const getAlpineiqOverview = createAsyncThunk(
  "get_alpineiq_overview",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/alpineiq/overview/`,
        {},
        config
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
